module.exports = __webpack_public_path__ + "img/356.d82c8fd9.jpg";